/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        background: ${getColor("common.background")};
        border: 1px solid ${getColor("common.ui12")};
        border-top: 0;
        padding: 15px;
    `,
};

searchWithinStyles.titleText = {
    variant: "h6",
    lineHeight: "20px",
    css: css`
        margin-bottom: 8px;
    `,
};
